import { ChangeDetectionStrategy, Component, computed, input, type InputSignal, type Signal, inject } from '@angular/core';
import { LocationFacade } from '../../services/location.facade';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-time-zone-view',
    templateUrl: './time-zone-view.component.html',
})
export class TimeZoneViewComponent {
    public readonly businessTimeZone: InputSignal<string> = input.required<string>();

    public readonly timeZones: Signal<Record<string, string> | null> = inject(LocationFacade).timeZones;

    public readonly selectedTimeZoneValue: Signal<string> = computed(() => {
        const timeZones = this.timeZones();
        const businessTimeZone = this.businessTimeZone();

        return timeZones ? timeZones[businessTimeZone] : '';
    });
}
